
      const setting = {
  "securitySetting": "Настройки безопасности",
  "resetPassword": "Сброс пароля",
  "resetPasswordDescription": "Пароль сброшен"
}
      export default setting
    